import React, { useState, useEffect } from "react";
import styles from "./PopupModal.module.scss";
import popupImage from "../../assets/popup-bg.jpg";

interface PopupModalProps {
    onClose: () => void;
    onSubmissionSuccess: (status: string, couponCode?: string) => void;
}

const API_BASE_URL = "https://main-inbound-automation.vercel.app/api/contact";
const BRAND = "naarintl";

const PopupModal: React.FC<PopupModalProps> = ({ onClose, onSubmissionSuccess }) => {
    const [step, setStep] = useState(1);
    const [userType, setUserType] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        country: "",
        email: "",
        phone: "",
    });

    const popupContentRef = React.useRef<HTMLDivElement>(null);

    // Handle click outside to close
    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const countries = [
        "Afghanistan",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antarctica",
        "Antigua and Barbuda",
        "Armenia",
        "Aruba",
        "Asia/Pacific Region",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Åland Islands",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Brazil",
        "British Indian Ocean Territory",
        "British Virgin Islands",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Canary Islands",
        "Cape Verde",
        "Caribbean Netherlands",
        "Cayman Islands",
        "Central African Republic",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos (Keeling) Islands",
        "Colombia",
        "Comoros",
        "Congo",
        "Costa Rica",
        "Cote d'Ivoire",
        "Croatia",
        "Cuba",
        "Curaçao",
        "Cyprus",
        "Czech Republic",
        "Democratic Republic of the Congo",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "East Timor",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Ethiopia",
        "Europe",
        "Falkland Islands",
        "Faroe Islands",
        "Fiji",
        "Finland",
        "France",
        "French Guiana",
        "French Polynesia",
        "French Southern and Antarctic Lands",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guadeloupe",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Heard Island and McDonald Islands",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Kosovo",
        "Kuwait",
        "Kyrgyzstan",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macau",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands",
        "Martinique",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Micronesia",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Myanmar (Burma)",
        "Macedonia (FYROM)",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "Netherlands Antilles",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Niue",
        "Norfolk Island",
        "North Korea",
        "Northern Mariana Islands",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Palestine",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Pitcairn Islands",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Réunion",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Barthélemy",
        "Saint Helena",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Martin",
        "Saint Pierre and Miquelon",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Sint Maarten",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Georgia and the South Sandwich Islands",
        "South Korea",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan",
        "Suriname",
        "Svalbard and Jan Mayen",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Syria",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Türkiye",
        "Turkmenistan",
        "Turks and Caicos Islands",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "United States",
        "United States Minor Outlying Islands",
        "Uruguay",
        "Uzbekistan",
        "U.S. Virgin Islands",
        "Vanuatu",
        "Vatican City",
        "Venezuela",
        "Vietnam",
        "Wallis and Futuna",
        "Western Sahara",
        "Yemen",
        "Zambia",
        "Zimbabwe",
    ];

    const handleSelection = (value: string) => {
        setUserType(value);
        if (error) {
            setError("");
        }
    };

    const handleNext = () => {
        if (userType) {
            setError("");
            setStep(2);
        } else {
            setError("Please make a selection to continue.");
        }
    };

    // Scroll to top of popup content when step changes to 2
    useEffect(() => {
        if (step === 2 && popupContentRef.current) {
            popupContentRef.current.scrollTop = 0;
        }
    }, [step]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(API_BASE_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    action: "popup",
                    brand: BRAND,
                    userType: userType,
                    type: userType,
                    firstName: formData.firstName,
                    lastName: formData.lastName,
                    email: formData.email,
                    phone: formData.phone,
                    country: formData.country,
                }),
            });

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result.message || "Submission failed");
            }

            // For consumers, pass the coupon code
            if (result.coupon_code) {
                onSubmissionSuccess("consumer", result.coupon_code);
            } else {
                onSubmissionSuccess("business");
            }
        } catch (error) {
            console.error("An error occurred:", error);
            onSubmissionSuccess("general");
        } finally {
            setLoading(false);
            onClose();
        }
    };

    const renderStep2 = () => {
        const isConsumer = userType === "Consumer";

        return (
            <form onSubmit={handleSubmit} className={loading ? styles.formDisabled : ""}>
                <div className={styles.formRowInline}>
                    <div className={styles.formGroup}>
                        <label htmlFor="firstName">First Name*</label>
                        <input type="text" id="firstName" name="firstName" required onChange={handleChange} value={formData.firstName} disabled={loading} />
                    </div>
                    <div className={styles.formGroup}>
                        <label htmlFor="lastName">Last Name*</label>
                        <input type="text" id="lastName" name="lastName" required onChange={handleChange} value={formData.lastName} disabled={loading} />
                    </div>
                </div>
                <div className={styles.formGroup}>
                    <label htmlFor="country">Country*</label>
                    <select id="country" name="country" required onChange={handleChange} value={formData.country} disabled={loading}>
                        <option value="">Select an Option...</option>
                        {countries.map((country) => (
                            <option key={country} value={country}>
                                {country}
                            </option>
                        ))}
                    </select>
                </div>
                <div className={styles.formGroup}>
                    <label htmlFor="phone">Phone*</label>
                    <input type="tel" id="phone" name="phone" required onChange={handleChange} value={formData.phone} disabled={loading} />
                </div>
                <div className={styles.formGroup}>
                    <label htmlFor="email">Email*</label>
                    <input type="email" id="email" name="email" required onChange={handleChange} value={formData.email} disabled={loading} />
                </div>
                <button type="submit" disabled={loading}>
                    {loading ? "Submitting..." : <strong>CLAIM MY PRIZE</strong>}
                </button>
            </form>
        );
    };

    return (
        <div className={styles.overlay} onClick={handleOverlayClick}>
            <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
                <div className={styles.popupImage} style={{ backgroundImage: `url(${popupImage})` }} />
                <div className={styles.popupContent} ref={popupContentRef}>
                    <button onClick={onClose} className={styles.closeButton} disabled={loading}>
                        &times;
                    </button>
                    {step === 1 && (
                        <>
                            <h2>LET'S LIGHT THINGS UP!</h2>
                            <p>Unlock a Special Perk in less than a minute!</p>
                            <form>
                                <div className={styles.radioGroup}>
                                    <p>Which one describes you best?</p>
                                    <div>
                                        <input type="radio" id="retailer" name="userType" value="Shop/Retailer" onChange={(e) => handleSelection(e.target.value)} />
                                        <label htmlFor="retailer">Retailer / Shop</label>
                                    </div>
                                    <div>
                                        <input type="radio" id="distributor" name="userType" value="Distributor/Wholesaler" onChange={(e) => handleSelection(e.target.value)} />
                                        <label htmlFor="distributor">Wholesaler / Distributor</label>
                                    </div>
                                    <div>
                                        <input type="radio" id="consumer" name="userType" value="Consumer" onChange={(e) => handleSelection(e.target.value)} />
                                        <label htmlFor="consumer">Consumer</label>
                                    </div>
                                </div>
                                {error && <p className={styles.error}>{error}</p>}
                                <button type="button" onClick={handleNext}>
                                    <strong>Next →</strong>
                                </button>
                            </form>
                        </>
                    )}
                    {step === 2 && renderStep2()}
                </div>
            </div>
        </div>
    );
};

export default PopupModal;
